import React from "react";
import useObjectInput from "../../../../../hooks/useObjectInput";

const GOIFieldTime = ({ disabled, value, inputData }) => {
  const { onInputValueChange } = useObjectInput();

  const { placeholder } = inputData.options;

  const handleValueChange = (e) => {
    let inputValue = e.target.value;
    onInputValueChange(inputData.id, inputValue);
  };

  return (
    <input
      type="time"
      defaultValue={value}
      placeholder={placeholder}
      onChange={handleValueChange}
      disabled={disabled}
    />
  );
};

export default GOIFieldTime;
